(function () {
    'use strict';

    angular
        .module('financial')
        .controller('RevenueCostReportController', RevenueCostReportController);

    RevenueCostReportController.$inject = ['ExpoService', '$uibModal', 'ngDialog', 'RevenueCostBreakdownService'];


    function RevenueCostReportController(ExpoService,$uibModal, ngDialog, RevenueCostBreakdownService) {
        var vm                   = this;
        vm.flag                  = false;
        vm.expanded              = false;
        vm.costFairAdvertising   =  {};
        vm.tabClass              = {'detailed-report':'active', 'load-cost':'', 'seller-expense':'', 'goals':''};     
        vm.widget                = [];
        vm.cityLength            = 1;   
        vm.widgetCostLeadRegistered = [];
        vm.widgetCostLeadAccepted = [];
        vm.widgetCostLeadAttended = [];
        vm.expo                  = [];
        vm.expoSelected          = '';
        vm.semesterSelected      = [];
        vm.cost                  = [];   
        vm.costSecondLevel       = [];   
        vm.revenue               = [];   
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.selectSemester        = selectSemester;
        vm.getRevenueFirstLevel  = getRevenueFirstLevel;
        vm.getCostFirstLevel     = getCostFirstLevel;
        vm.getSecondLevel        = getSecondLevel;
        vm.getSecondLevelRevenue  = getSecondLevelRevenue;

        vm.getSecondLevelAdvertising = getSecondLevelAdvertising;
        vm.getThirdLevelAdvertising = getThirdLevelAdvertising;
        vm.getInvoiceWidget      = getInvoiceWidget;
        
        vm.getSummary           = getSummary;
        /* LEAD */
        vm.getWidgetCostPerRegisteredLead = getWidgetCostPerRegisteredLead;
        vm.getWidgetCostPerAcceptedLead = getWidgetCostPerAcceptedLead;
        vm.getWidgetCostPerAttendedLead = getWidgetCostPerAttendedLead;

        /* SELLER EXPENSE */
        vm.getWidgetSellerExpenses  = getWidgetSellerExpenses;

        /* GOALS */
        vm.getWidgetGoals = getWidgetGoals;

        vm.getByFilter  = getByFilter;      
        vm.setActiveTab = setActiveTab;      
        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            vm.selectSemester();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpoBySemester () {
            ExpoService.getExpoBySemester(vm.semesterSelected).then(function(response){
                vm.expo = response.data;                 
                 
                // Remove High School tour, for while.
                let i = vm.expo.length;
                while (i--) {
                    if (vm.expo[i].is_school_visit == 1) {
                        vm.expo.splice(vm.expo.indexOf(vm.expo[i]), 1);
                    }
                }
            }).catch(function(err) {
            });
        }

        function selectSemester () {
            ExpoService.getSemesters().then(function(response){
                vm.semester = response.data;
            }).catch(function(err) {
            });
        }
        
        function getRevenueFirstLevel () {
            vm.revenue = [];
            vm.cityLength = 1;
            RevenueCostBreakdownService.getRevenueFirstLevel(vm.query).then(function(response){
                
                vm.revenue = response.data;
                vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
            }).catch(function(err) {
            });
        }
        function getCostFirstLevel () {
            vm.cost = [];
            RevenueCostBreakdownService.getCostFirstLevel(vm.query).then(function(response){
                vm.cost = response.data;
                console.log(vm.cost);
                debugger;
                vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
                vm.flag = true;
            }).catch(function(err) {
            });
        }
        function getSecondLevel (item) {
            if (item.expanded !== true) {
                vm.query = {};
                if( vm.expoSelected && vm.expoSelected !== '') {
                    vm.query['expo_id'] = vm.expoSelected.id;
                }
                if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                    vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
                }
                vm.query['key']  = item['key'];
                RevenueCostBreakdownService.getSecondLevel(vm.query).then(function(response){
                    item.sub_items = response.data;
                    vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
                    item.expanded = true;
                    vm.flag = true;
                }).catch(function(err) {
                });
            } else {
                item.expanded = false;
            }
        }
        function getSecondLevelRevenue (item, expo_id) {
           
            if (item.expanded !== true) {
                vm.query = {};
                if( expo_id && expo_id !== '') {
                    vm.query['expo_id'] = expo_id;
                }
                if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                    vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
                }
                vm.query['key']  = item['key'];
                RevenueCostBreakdownService.getSecondLevelRevenue(vm.query).then(function(response){
                    item.sub_items = response.data;
                    vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
                    item.expanded = true;
                    vm.flag = true;
                }).catch(function(err) {
                });
            } else {
                item.expanded = false;
            }
        }
        function getSecondLevelAdvertising (item) {
            if (item.expanded !== true) {
                vm.query = {};
                if( vm.expoSelected && vm.expoSelected !== '') {
                    vm.query['expo_id'] = vm.expoSelected.id;
                }
                if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                    vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
                }
                RevenueCostBreakdownService.getSecondLevelAdvertising(vm.query).then(function(response){
                    item.sub_items = response.data;
                    vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
                    item.expanded = true;
                    vm.flag = true;
                }).catch(function(err) {
                });
            } else {
                item.expanded = false;
            }
        }

        function getThirdLevelAdvertising (item) {
            if (item.expanded !== true) {
                vm.query = {};
                if( vm.expoSelected && vm.expoSelected !== '') {
                    vm.query['expo_id'] = vm.expoSelected.id;
                }
                if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                    vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
                }
                RevenueCostBreakdownService.getThirdLevelAdvertising(vm.query).then(function(response){
                    item.sub_others_items = response.data;
                    vm.cityLength = Object.keys(vm.cost['cities_th']).length + 3;
                    item.expanded = true;
                    vm.flag = true;
                }).catch(function(err) {
                });
            } else {
                item.expanded = false;
            }
        }
        function getInvoiceWidget () {
            vm.widget = [];
            RevenueCostBreakdownService.getInvoiceWidget(vm.query).then(function(response){
                vm.widget = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }
        function getWidgetCostPerRegisteredLead () {
            vm.widgetCostLeadRegistered = [];
            vm.query = {};
            vm.query['expos_id'] = [];
            angular.forEach(vm.revenue, function(value, key) {
                if (key !== '0') {
                    vm.query['expos_id'].push(key);    
                }
            });
            vm.query['expos_id'] = JSON.stringify(vm.query['expos_id']);
            vm.query['total_cities']  = vm.cost['total_cities'];
            //vm.query['total_general'] = vm.cost['total_general'];
            vm.query['total_general'] = vm.cost['total'][28];
            angular.forEach(vm.cost['items'],function(item){
                if (item.item_name == 'FAIR ADVERTISING & MARKETING') {
                    vm.query['item'] = item;
                }    
            });
            RevenueCostBreakdownService.getWidgetCostPerRegisteredLead(vm.query).then(function(response){
                vm.widgetCostLeadRegistered = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }
        
        function getWidgetCostPerAcceptedLead () {
            vm.query = {};
            vm.query['expos_id'] = [];
            angular.forEach(vm.revenue, function(value, key) {
                if (key !== '0') {
                    vm.query['expos_id'].push(key);    
                }
            });
            vm.query['expos_id'] = JSON.stringify(vm.query['expos_id']);
            vm.query['total_cities']  = vm.cost['total_cities'];
            //vm.query['total_general'] = vm.cost['total_general'];
            vm.query['total_general'] = vm.cost['total'][28];
            angular.forEach(vm.cost['items'],function(item){
                if (item.item_name == 'FAIR ADVERTISING & MARKETING') {
                    vm.query['item'] = item;
                }    
            });
            RevenueCostBreakdownService.getWidgetCostPerAcceptedLead(vm.query).then(function(response){
                vm.widgetCostLeadAccepted = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }
        function getWidgetCostPerAttendedLead () {
            vm.widgetCostLeadAttended = [];
            vm.query = {};
            vm.query['expos_id'] = [];
            angular.forEach(vm.revenue, function(value, key) {
                if (key !== '0') {
                    vm.query['expos_id'].push(key);    
                }
            });
            vm.query['expos_id'] = JSON.stringify(vm.query['expos_id']);
            vm.query['total_cities']  = vm.cost['total_cities'];
            //vm.query['total_general'] = vm.cost['total_general'];
            vm.query['total_general'] = vm.cost['total'][28];
            angular.forEach(vm.cost['items'],function(item){
                if (item.item_name == 'FAIR ADVERTISING & MARKETING') {
                    vm.query['item'] = item;
                    vm.costFairAdvertising = item; 
                }    
            });
            RevenueCostBreakdownService.getWidgetCostPerAttendedLead(vm.query).then(function(response){
                vm.widgetCostLeadAttended = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }

        function getWidgetSellerExpenses () {
            vm.widgetSellerExpenses = [];
            vm.sellerExpensesFlag = false;
            let query = {};
            if( typeof vm.expoSelected.id !== 'undefined') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if( typeof vm.semesterSelected.semester !== 'undefined') {
                query['semester'] = vm.semesterSelected.semester;
            }
            RevenueCostBreakdownService.getWidgetSellerExpenses(query).then(function(response){
                vm.sellerExpensesFlag = true;
                vm.widgetSellerExpenses = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }

        function getWidgetGoals () {
            vm.widgetGoals = [];
            vm.goalsFlag = false;
            let query = {};
            query['goal_type'] = 'report';
            if( typeof vm.expoSelected.id !== 'undefined') {
                query['expos_ids'] = [vm.expoSelected.id];
            }
            if( typeof vm.semesterSelected.semester !== 'undefined') {
                query['semester'] = vm.semesterSelected.semester;
            }
            RevenueCostBreakdownService.getWidgetGoals(query).then(function(response){
                vm.goalsFlag = true;
                vm.widgetGoals = response.data;
                vm.flag = true;
            }).catch(function(err) {
            });
        }

        function getSummary () {
            
            vm.summary = [];
            vm.summaryFlag = false;
            let query = {};
            
            if( typeof vm.expoSelected.id !== 'undefined') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if( typeof vm.semesterSelected.semester !== 'undefined') {
                query['semester'] = vm.semesterSelected.semester;
            }
            RevenueCostBreakdownService.getWidgetSummary(query).then(function(response){
                vm.summaryFlag = true;
                vm.summary = response.data;
            }).catch(function(err) {
            });
        }

        function setActiveTab(tabName) {

            vm.tabClass = {'detailed-report':'', 'lead-cost':'', 'seller-expense':'', 'goals':''};
            vm.tabClass[tabName] = 'active';
            if (tabName === 'lead-cost') {
                vm.getWidgetCostPerRegisteredLead();
                vm.getWidgetCostPerAcceptedLead();
                vm.getWidgetCostPerAttendedLead();
            }
            if (tabName === 'seller-expense') {
                vm.getWidgetSellerExpenses();
            }
            if (tabName === 'goals') {
                vm.getWidgetGoals();
            }
        }
    
        function getByFilter () {
            setActiveTab('detailed-report');
            vm.flag         = false;
            vm.query        = {};
            
            if( vm.semesterSelected.semester && vm.semesterSelected.semester !== '') {
                vm.query['semester']   = vm.semesterSelected.semester.replace("-",".");
            }
            if( vm.expoSelected && vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            vm.query['page'] = vm.page;
            vm.goalsFlag = false;
            this.getRevenueFirstLevel();
            this.getCostFirstLevel();
            this.getInvoiceWidget();
            this.getSummary();
        }

        activate();
    }

})();